import { createProvider } from '@frontend/store';
import { FormsSubmissionV2DetailsStore, FormsSubmissionV2DetailsState } from './types';

const INITIAL_STATE: FormsSubmissionV2DetailsState = {
  activeFormId: null,
  activeAttachmentId: null,
  shouldShowAsMobileView: false,
  hasSelectedItem: false,
};

export const { Provider: FormsSubmissionDetailsV2StoreProvider, useStore: useFormsSubmissionDetailsV2Store } =
  createProvider<FormsSubmissionV2DetailsStore>()((set) => ({
    ...INITIAL_STATE,

    selectAttachment: (attachmentId) =>
      set({
        activeAttachmentId: attachmentId,
        activeFormId: null,
        hasSelectedItem: true,
      }),

    selectForm: (formId) =>
      set({
        activeAttachmentId: null,
        activeFormId: formId,
        hasSelectedItem: true,
      }),

    setShouldShowAsMobileView: (shouldShowAsMobileView) => set({ shouldShowAsMobileView }),
    clearSelectedItem: () =>
      set({
        activeAttachmentId: null,
        activeFormId: null,
        hasSelectedItem: false,
      }),
  }));
